import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
import { environment } from 'src/environments/environment';
import { AuthService } from 'src/services/auth.service';
import { LocalStorageService } from 'src/services/localStorageService.service';

@Component({
  selector: 'app-servcies-layout',
  templateUrl: './servcies-layout.component.html',
  styleUrls: ['./servcies-layout.component.css']
})
export class ServciesLayoutComponent {

  lang:string;
  isProduction=false;
  mainPath = "" // قراءة القيمة من environment
  downFooterLogoPicSrc = "" // قراءة القيمة من environment
  upFooterLogoPicSrc = "" // قراءة القيمة من environment
  SectionId = "" // قراءة القيمة من environment


  //6652dd41387bcc53135c74b8

  constructor(private authService:AuthService,private translate: TranslateService,
    private cookieService: CookieService,
    private localStorageService:LocalStorageService,
    ) {

      this.lang=cookieService.get('lang');
      //this.lang="ar";
      this.isProduction=environment.production;
      this.mainPath= environment.MainPath;
      this.SectionId= environment.SectionId;
      this.downFooterLogoPicSrc= environment.DownFooterLogoPicSrc;
      this.upFooterLogoPicSrc= environment.UpFooterLogoPicSrc;

  }

  ngOnInit() {
    this.localStorageService.clearAllCookies();
  }


  getYear():string{
    return new Date().getFullYear().toString();
  }

  logout(){
    this.authService.removeToken();
    this.cookieService.delete('loginBy');
    location.href="/";
  }
  

  changeLanguage(){

    this.lang=="ar"? this.lang= "en": this.lang = "ar";

    this.translate.use(this.lang);
    this.cookieService.set('lang',this.lang);

    setTimeout(() => {
      location.reload();
    }, 500);
  }
  
}
